import { useEffect, useState } from "react";
import {
  createGame,
  getGame,
  updateGame,
  getTeams,
  getTeamAthletes,
} from "../../services/api";
import { useParams, useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import PlayersSelector from "../../components/Scout/PlayersSelector";

export default function GameForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    date: "",
    time: "",
    league: "",
    season: "",
    bestoff: 5,
    pontosset: [25, 15],
    teams: { home: {}, away: {} },
    homeOrder: [],
    awayOrder: [],
    setterPos: [0, 0],
    serv: "*",
  });
  const [teams, setTeams] = useState([]);
  const [homeAthletes, setHomeAthletes] = useState([]);
  const [awayAthletes, setAwayAthletes] = useState([]);

  const loadTeams = async () => {
    const res = await getTeams();
    setTeams(res.data);
  };

  const loadAthletes = async (teamId, isHome) => {
    const res = await getTeamAthletes(teamId);
    const athletes = res.data.athletes.map((item) => ({
      number: item.number, // ou item.athlete.number dependendo da estrutura real
      name: item.athlete.name,
      function: item.function || item.athlete.function,
      surname: item.athlete.surname,
    }));

    if (isHome) setHomeAthletes(athletes);
    else setAwayAthletes(athletes);
  };

  useEffect(() => {
    loadTeams();
    if (id) {
      getGame(id).then(({ data }) => {
        setForm({
          ...data,
          serv: data.scout[0].set.serv,
          homeOrder: data.scout[0]["*"],
          awayOrder: data.scout[0].a,
          setterPos: [data.scout[0].sett[0], data.scout[0].sett[1]],
        });

        if (data.teams.home?._id) {
          loadAthletes(data.teams.home._id._id, true);
          //   loadAthletes("683b2fd0374ef5730a0a17f5", true);
        }
        if (data.teams.away?._id) {
          loadAthletes(data.teams.away._id._id, false);
          //   loadAthletes("683b3138374ef5730a0a1805", false);
        }
      });
    }
  }, [id]);

  const handleSubmit = async () => {
    const homePlayers = form.homeOrder.map((num) => {
      const athlete = homeAthletes.find((a) => a.number === num);
      return {
        number: num,
        function: athlete?.function || "",
        name: athlete?.name || "",
        surname: athlete?.surname || "",
      };
    });

    const awayPlayers = form.awayOrder.map((num) => {
      const athlete = awayAthletes.find((a) => a.number === num);
      return {
        number: num,
        function: athlete?.function || "",
        name: athlete?.name || "",
        surname: athlete?.surname || "",
      };
    });

    const gameData = {
      ...form,
      teams: {
        home: {
          _id: form.teams.home._id,
          sets: form.teams.home.sets ?? 0,
        },
        away: {
          _id: form.teams.away._id,
          sets: form.teams.away.sets ?? 0,
        },
      },
      players: {
        home: homePlayers,
        away: awayPlayers,
      },
      homeOrder: form.homeOrder,
      awayOrder: form.awayOrder,
      setterPos: form.setterPos,
      pontosset: form.pontosset,
      serv: form.serv,
    };

    if (id) {
      await updateGame(id, gameData);
    } else {
      await createGame(gameData);
    }

    navigate("/admin/games");
  };

  return (
    <div className="p-6 max-w-3xl mt-20 space-y-4">
      <h1 className="text-xl font-bold">{id ? "Editar" : "Nova"} Partida</h1>
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="Data"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
        />
        <Input
          placeholder="Hora"
          value={form.time}
          onChange={(e) => setForm({ ...form, time: e.target.value })}
        />
        <Input
          placeholder="Liga"
          value={form.league}
          onChange={(e) => setForm({ ...form, league: e.target.value })}
        />
        <Input
          placeholder="Temporada"
          value={form.season}
          onChange={(e) => setForm({ ...form, season: e.target.value })}
        />
        <div>
          Melhor de:
          <Input
            type="number"
            placeholder="Best Of"
            value={form.bestoff}
            onChange={(e) => setForm({ ...form, bestoff: +e.target.value })}
          />
        </div>
        <div className="flex gap-2">
          [regulares, tie-break]
          {[0, 1].map((i) => (
            <Input
              key={i}
              type="number"
              placeholder={`Pontos Set ${i + 1}`}
              value={form.pontosset[i]}
              onChange={(e) => {
                const pts = [...form.pontosset];
                pts[i] = +e.target.value;
                setForm({ ...form, pontosset: pts });
              }}
            />
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <select
          value={form.teams.home?._id?._id || ""}
          onChange={(e) => {
            const team = teams.find((t) => t._id === e.target.value);
            setForm({
              ...form,
              teams: {
                ...form.teams,
                home: {
                  _id: team._id,
                  sets: form.teams.home?.sets || 0,
                },
              },
            });
            loadAthletes(team._id, true);
          }}
        >
          <option value="">-- Selecione Time Casa --</option>
          {teams.map((t) => (
            <option key={t._id} value={t._id}>
              {t.name}
            </option>
          ))}
        </select>
        <select
          value={form.teams.away?._id?._id || ""}
          onChange={(e) => {
            const team = teams.find((t) => t._id === e.target.value);
            setForm({
              ...form,
              teams: {
                ...form.teams,
                away: {
                  _id: team._id, // Armazena apenas o ID do time
                  sets: form.teams.away?.sets || 0, // Mantém os sets existentes ou 0
                },
              },
            });
            loadAthletes(team._id, false);
          }}
        >
          <option value="">-- Selecione Time Visitante --</option>
          {teams.map((t) => (
            <option key={t._id} value={t._id}>
              {t.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Saque inicial:</label>
        <select
          value={form.serv}
          onChange={(e) => setForm({ ...form, serv: e.target.value })}
        >
          <option value="*">Time Casa</option>
          <option value="a">Time Visitante</option>
        </select>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <PlayersSelector
          label="Escalação Time Casa"
          athletes={homeAthletes}
          selected={form.homeOrder}
          onChange={(order) => setForm({ ...form, homeOrder: order })}
          isHome={true}
        />
        <PlayersSelector
          label="Escalação Time Visitante"
          athletes={awayAthletes}
          selected={form.awayOrder}
          onChange={(order) => setForm({ ...form, awayOrder: order })}
          isHome={false}
        />
      </div>
      PLACAR
      <Input
        type="number"
        placeholder="Sets Home"
        value={form.teams.home?.sets ?? 0}
        onChange={(e) =>
          setForm({
            ...form,
            teams: {
              ...form.teams,
              home: { ...form.teams.home, sets: +e.target.value },
            },
          })
        }
      />
      <Input
        type="number"
        placeholder="Sets Away"
        value={form.teams.away?.sets ?? 0}
        onChange={(e) =>
          setForm({
            ...form,
            teams: {
              ...form.teams,
              away: { ...form.teams.away, sets: +e.target.value },
            },
          })
        }
      />
      <div>
        <label>Posição dos Levantadores [home, away]</label>
        <Input
          value={form.setterPos.join(",")}
          onChange={(e) => {
            const parts = e.target.value.split(",").map((n) => parseInt(n));
            setForm({ ...form, setterPos: parts });
          }}
        />
      </div>
      <Button className="mt-4" onClick={handleSubmit}>
        {id ? "Salvar" : "Criar"}
      </Button>
      <Button
        className="mt-4 ml-4"
        onClick={() => {
          navigate("/admin/games");
        }}
      >
        Cancelar
      </Button>
    </div>
  );
}
